"use client";

import { useEffect, useState } from "react";

export function LocalTrustedModeBanner() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    fetch("/api/auth/local-trusted-mode", { cache: "no-store" })
      .then((response) => response.ok ? response.json() : null)
      .then((data: { enabled?: boolean } | null) => {
        if (active) setEnabled(data?.enabled === true);
      })
      .catch(() => {
        if (active) setEnabled(false);
      });
    return () => { active = false; };
  }, []);

  if (!enabled) return null;

  return (
    <div
      role="status"
      className="fixed bottom-3 left-1/2 z-[70] -translate-x-1/2 rounded-full border border-[var(--primary-edge,rgba(20,184,166,0.3))] bg-[var(--surface-raised,rgba(10,10,10,0.88))] px-4 py-2 text-[11px] font-semibold text-[var(--role-link,#5eead4)] shadow-[0_8px_28px_rgba(0,0,0,0.45)] backdrop-blur-xl"
    >
      מצב מקומי מהימן · אימות המכשיר מושבת
    </div>
  );
}
